import { SECTION_META, SectionType } from './sectionMeta';

export const SectionIcon = ({ sectionType }: { sectionType: SectionType }) => {
  const Svg = SECTION_META[sectionType].icon;
  return (
    <Svg aria-hidden="true" focusable="false" style={{ width: 20, height: 20, flexShrink: 0, display: 'block' }} />
  );
};
